import type { ExtractDefaultPropTypes, PropType } from 'vue'

export const fileDisplayCommonProps = {
  record: {
    type: Object as PropType<ApiFile.Item>,
    default: () => ({})
  }
}
const closeable = {
  type: Boolean as PropType<boolean>,
  default: false
}
const viewRaw = {
  type: Boolean as PropType<boolean>,
  default: false
}
export const fileDisplayNormalProps = {
  ...fileDisplayCommonProps,
  closeable,
  viewRaw
}

export type FileDisplayNormalProps = ExtractDefaultPropTypes<typeof fileDisplayNormalProps>

const files = {
  type: Array as PropType<ApiFile.Item[]>,
  default: () => []
}
const colAttrs = {
  type: Object as PropType<Record<string, any>>,
  default: () => ({ span: 12, xl: 8, xxl: 6 })
}

export const fileDisplayNormalsProps = {
  files,
  colAttrs,
  closeable,
  viewRaw
}

export type FileDisplayNormalsProps = ExtractDefaultPropTypes<typeof fileDisplayNormalsProps>

export const fileDisplaySimpleProps = {
  ...fileDisplayCommonProps,
  closeable
}

export type FileDisplaySimpleProps = ExtractDefaultPropTypes<typeof fileDisplaySimpleProps>

export const fileDisplaySimplesProps = {
  files,
  colAttrs,
  closeable
}

export type FileDisplaySimplesProps = ExtractDefaultPropTypes<typeof fileDisplaySimplesProps>

export const fileDisplayDetailProps = {
  ...fileDisplayCommonProps
}

export type FileDisplayDetailProps = ExtractDefaultPropTypes<typeof fileDisplayDetailProps>

export const fileDisplayLocalProps = {
  fileName: {
    type: String as PropType<string>
  },
  size: {
    type: Number as PropType<number>
  },
  theme: {
    type: String as PropType<string>,
    default: 'light'
  },
  block: {
    type: Boolean as PropType<boolean>,
    default: false
  },
  closeable
}

export type FileDisplayLocalProps = ExtractDefaultPropTypes<typeof fileDisplayLocalProps>

export const fileDisplayLocalsProps = {
  files,
  colAttrs,
  closeable
}
